import React from "react";
import { CertificateAndComplianceProps } from "./CertificateAndCompliance";
import ProductQualityMobile from "../ProductQuality/ProductQualityMobile";

const CertificateAndComplianceMobile: React.FC<CertificateAndComplianceProps> = ({ ...props }) => {
	return <ProductQualityMobile {...props} />;
};

export default CertificateAndComplianceMobile;
